import React, { FC, ReactElement, memo } from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
// Components
// Resources
import { stringsRes } from '../../resources/strings';
import Text from '../text';

interface NoteCardProps {
    title: string;
    note: string;
    onEdit?: () => void;
    // Opt-in, for translated strings carrying markup such as <b>. Never enable it for user input:
    // the driver message and the ride reason are typed by the rider.
    dangerouslySetInnerHTML?: boolean;
}

const NoteCard: FC<NoteCardProps> = (props): ReactElement => {
    const { onEdit, note, title, dangerouslySetInnerHTML = false } = props;
    const classes = useStyles();

    return (
        <div>
            <div className={classes.headerContainer}>
                <Text.H35 text={title} />
                {onEdit && (
                    <Button className={classes.noteCardButton} onClick={onEdit}>
                        {stringsRes.booking.edit}
                    </Button>
                )}
            </div>
            {dangerouslySetInnerHTML ? (
                <Typography variant="caption" dangerouslySetInnerHTML={{ __html: note }} />
            ) : (
                <Typography variant="caption">{note}</Typography>
            )}
        </div>
    );
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        headerContainer: {
            display: 'flex',
            flex: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
        },
        noteCardButton: {
            color: theme.palette.primary.main,
            fontWeight: 400,
            fontSize: 14,
            lineHeight: '14px',
            letterSpacing: 0.2,
            textDecoration: 'underline',
            '&:hover': {
                backgroundColor: 'transparent',
            },
        },
    }),
);

export default memo(NoteCard);
